export default __webpack_public_path__ + "static/media/programmer-man.9a830325.svg";